import React from "react";
import { createRoot } from 'react-dom/client';
import App from '../components/CourseApplication/App'
import 'primeicons/primeicons.css';

document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("react-course-application-container");
  if (container) {
    createRoot(container).render(<App />);
  }
});
